import React from 'react';


const Blogs = () => {
    return (
        <div className='d-flex align-items-center justify-content-center my-5'>
            <img src='https://ps.w.org/quick-coming-soon/assets/icon-256x256.gif?rev=2286699' alt="img not found" width='50%' />
        </div>
    );
};

export default Blogs;